import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import React, {
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  columnsTableAdded,
  columnsTableMenu,
  optionsLieuDung,
} from "./PrescriptionTable.config";
import "./PrescriptionTable.scss";
import { technicalService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import AllocateTableSearch from "./AllocateTableSearch/AllocateTableSearch";
import ServiceTable from "./ServiceTable/ServiceTable";
import { ListActionButton } from "components/common";

const Services = React.forwardRef((props: any, ref) => {
  // redux
  let dispatch = useAppDispatch();

  const [dataSource, setDataSource] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [form] = Form.useForm();

  const aTSRef = useRef<any>();
  const sTRef = useRef<any>();
  const [listService, setListService] = useState<any>([]);
  const [selectedServices, setSelectedServices] = useState<any>([]);
  // console.log("🚀 ~ Services ~ selectedServices:", selectedServices);

  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
    setData: setDataSource,
    setSelectedServices: setSelectedServices,
    getData: () => {
      return selectedServices;
    },
    clearItem: (value) => {
      setDataSource([...dataSource.filter((it) => it.tenDichVu !== value)]);
    },
  }));
  const openModal = async () => {
    setIsModalOpen(true);
  };
  const closeModal = async () => {
    setIsModalOpen(false);
  };

  const handleSave = async () => {
    await props.onSave();
    closeModal();
  };
  const [dmDichVu, setDmDichVu] = useState<any>([]);
  const fetchListTechnicalService = async (params) => {
    try {
      let response = await technicalService.getListTechnicalService(params);
      setDmDichVu(response);
    } catch (err) {
      console.log("🚀 ~ fetchListTechnicalService ~ err:", err);
    }
  };

  useEffect(() => {
    fetchListTechnicalService({
      page: 1,
      limit: 9999,
    });
  }, []);

  // const columns = columnsTableMenu.map((col) => {
  //   if (col.dataIndex === "tenDichVu") {
  //     return {
  //       ...col,
  //       options: [
  //         ...dmDichVu.map((it) => ({
  //           value: it.tenDichVu,
  //           label: it.tenDichVu,
  //         })),
  //       ],
  //     };
  //   } else return col;
  // });

  useEffect(() => {
    sTRef.current?.setData(listService);
  }, [listService]);

  // const handleDelete = (record) => {
  //   console.log(record);
  //   if (+record.soLuong > 1) {
  //     setSelectedServices((pre) => {
  //       return pre.map((e) =>
  //         e.id === record.id
  //           ? {
  //               ...e,
  //               soLuong: +(e.soLuong - 1),
  //             }
  //           : e
  //       );
  //     });
  //   } else
  //     setSelectedServices([
  //       ...selectedServices.filter((e) => e.id != record.id),
  //     ]);
  // };

  // columnsTableAdded.find((e) => e.dataIndex === "action").render = (
  //   v,
  //   r,
  //   i
  // ) => <ListActionButton deleteFunction={() => handleDelete(r)} />;
  return (
    <div className="modal">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        title={"Chọn dịch vụ bổ sung"}
        // width={selectedServices.length > 0 && selectedServices ? 1400 : 1080}
        width={1080}
      >
        <div className="prescription-table-container">
          <Row gutter={[16, 16]}>
            {/* <Col span={selectedServices.length > 0 && selectedServices ? 4 : 6}> */}
            <Col span={6}>
              <AllocateTableSearch
                ref={aTSRef}
                setListService={setListService}
              />
            </Col>
            {/* <Col
              span={selectedServices.length > 0 && selectedServices ? 14 : 18}
            >   */}
            <Col span={18}>
              <ServiceTable
                ref={sTRef}
                selectedServices={selectedServices}
                setSelectedServices={setSelectedServices}
              />
            </Col>
            {/* <Col span={24}>
                <TableDetail />
              </Col> */}
            {/* {selectedServices.length > 0 && selectedServices && (
              <Col span={6}>
                <Space direction="vertical">
                  <Typography.Text
                    strong
                    style={{ color: "green", fontSize: 16 }}
                  >
                    Dịch vụ đã bổ sung
                  </Typography.Text>
                  <Table
                    columns={columnsTableAdded}
                    dataSource={selectedServices}
                    bordered
                  />
                </Space>
              </Col>
            )} */}
            <Row>
              <Row gutter={[0, 8]} justify={"end"} style={{ gap: "4px" }}>
                <Button type="primary" onClick={closeModal} danger>
                  Hủy
                </Button>
                <Button type="primary" onClick={handleSave}>
                  Lưu lại
                </Button>
              </Row>
            </Row>
          </Row>
          {/* <Space direction="vertical" className="prescription-space">

            <Row gutter={[8, 8]}>
              <Col xs={24} md={24} sm={24} lg={24} xl={24}>
                <TableInputAdd
                  column={columns}
                  data={dataSource}
                  setData={setDataSource}
                  pagination={false}
                  // rowSelection={{
                  //   type: "checkbox",
                  //   onChange: onSelectRow,
                  //   selectedRowKeys: selectedRowKeys,
                  // }}
                  dichVu={dmDichVu}
                  count={count}
                  setCount={setCount}
                />
              </Col>
            </Row>
            <Row>
              <Row gutter={[0, 8]} justify={'end'} style={{gap: "4px"}}>
                <Button type="primary" onClick={closeModal} danger>Hủy</Button>
                <Button type="primary" onClick={handleSave}>Lưu lại</Button>
              </Row>
            </Row>
          </Space> */}
        </div>
      </Modal>
    </div>
  );
});

export default Services;
